export default __webpack_public_path__ + "static/media/maternity.4af41943.svg";